require('./bootstrap');

import Vue from 'vue'
import App from './views/App.vue'

import 'babel-polyfill'
import vuetify from './plugins/vuetify/vuetify'

import Vuex from 'vuex'
import appStore from './store'

import VueRouter from 'vue-router'
import appRoutes from './routes';
import { middlewarePipeline } from "./routes/middlewares"

/* Global mixins */
import LangManager from './plugins/lang-manager';
import Meta from "./mixins/Meta";

import CKEditor from '@ckeditor/ckeditor5-vue'


Vue.use(vuetify);


Vue.use(VueRouter);
const router = new VueRouter(appRoutes);

/**
 * Enable Vuex
 */
Vue.use(Vuex);
const store = new Vuex.Store(appStore);

Vue.use(CKEditor);

/**
* Mixins
*/
Vue.mixin(LangManager);
Vue.mixin(Meta);


router.beforeEach((to, from, next) => {
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });

    if (!to.meta.middleware) {
        return next()
    }
    const middleware = to.meta.middleware;

    const context = {
        to,
        from,
        next,
        store,
        router
    };
    return middleware[0]({
        ...context,
        next: middlewarePipeline(context, middleware, 1)
    })
});


new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),
}).$mount('#app');
